<h2 class="text-center"> Creating New Concept</h2>
<div class="alert alert-info" *ngIf="!isLoading && isError"> {{errorMessage}}</div>
<form [formGroup]="myForm" (ngSubmit)="submit()">
    <div class="form-group">
        <label for="file">File</label>
        <input
            formControlName="file"
            id="file"
            type="file"
            class="form-control"
            (change)="onFileChange($event)">
            <div *ngIf="f.file.touched && f.file.invalid" class="alert alert-danger">
                <div *ngIf="f.file.errors.required">File is required.</div>
            </div>
        </div>
        <fieldset class="text-center">
            <button class="btn btn-primary me-4" type="submit">Submit</button>
            <a class="btn btn-secondary" [routerLink]="['/admin/study/index']"> Close</a>
        </fieldset>

</form>
